import React from "react";
import { connect } from 'react-redux';
import UserForm from "./UserForm";
import * as Yup from "yup";
import * as actions from '../store/profileActions';
import History from "../../../History";
import { hasPermission } from "../../sc-utilities";

const UserInformation = props => {
    const { activeCustomerID, translations, loggedUser, updateUser, permissions } = props;
    const handleSubmit = async data => {
        let result = await updateUser({ ...data, ActiveCustomerID: activeCustomerID, UserID: loggedUser.UserID });
        if (result) {
            History.goBack()
        }
    };

    let initialValues = {
        FirstName: loggedUser && loggedUser.FirstName ? loggedUser.FirstName : '',
        LastName: loggedUser && loggedUser.LastName ? loggedUser.LastName : '',
        Username: loggedUser && loggedUser.Username ? loggedUser.Username : '',
        Email: loggedUser && loggedUser.Email ? loggedUser.Email : '',
        PhoneNumber: loggedUser && loggedUser.PhoneNumber ? loggedUser.PhoneNumber : '',
        Password: '',
        RepeatPassword: ''
    }

    let formSettings = {
        Validation: {
            FirstName: Yup.string().notRequired(),
            LastName: Yup.string().notRequired(),
            Username: Yup.string().notRequired(),
            Email: Yup.string()
                .email("Invalid email")
                .notRequired(),
            PhoneNumber: Yup.string().notRequired(),
            Password: Yup.string()
                .oneOf([Yup.ref("RepeatPassword"), null], "Passwords must match"),
            RepeatPassword: Yup.string()
                .oneOf([Yup.ref("Password"), null], "Passwords must match"),
        },
        ButtonSubmit: hasPermission(permissions, 'user_save') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    return (
        <UserForm
            formSettings={formSettings}
            initialValues={initialValues}
            handleSubmit={handleSubmit}
            translations={translations}
        />
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        loggedUser: state.core.login.user,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateUser: data => dispatch(actions.saveUser(data)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserInformation);
